/*
 * 所有请求数据接口都通过api这个模块导出
 */
import screen9 from './screen9';
import blockAPI from './blockAPI';

const api = {
    screen9,
    blockAPI
};
export default api;